export const measurementsEn: Record<string, string> = {
  'track_version_customer_measurements': 'Track and version customer measurements',
  'new_measurements': 'New Measurements',
  'create_new_measurement_set': 'Create New Measurement Set',
  'select_customer_placeholder': 'Select a customer',
  'measurement_notes_placeholder': 'Additional measurement notes, alterations needed, etc.',
  'select_customer_label': 'Select Customer',
  'compare_mode': 'Compare Mode',
  'previous_version': 'Previous Version',
  'current_version': 'Current Version',
  'shoulder_width_back': 'Shoulder Width (back)',
  'waist_length_back': 'Waist Length (back)',
  'waist_length_front': 'Waist Length (front)',
  'bust_circumference': 'Bust Circumference',
  'waist_circumference': 'Waist Circumference',
  'hip_circumference': 'Hip Circumference',
  'bust_height': 'Bust Height',
  'distance_between_breasts': 'Distance Between Breasts',
  'abdomen_circumference': 'Abdomen Circumference',
  'arm_circumference': 'Arm Circumference',
  'wrist_circumference': 'Wrist Circumference',
  'chest_circumference': 'Chest Circumference',
  'hip_upper': 'Hip Upper',
  'shoulder': 'Shoulder',
  'sleeve_length': 'Sleeve Length',
  'skirt_length': 'Skirt Length',
  'height': 'Height',
  'bust': 'Bust',
  'waist': 'Waist',
  'hips': 'Hips',
  'measurement_created_successfully': 'Measurement set created successfully',
  'failed_to_create_measurement': 'Failed to create measurement set',
  'failed_to_fetch_measurements': 'Failed to fetch measurements',

  // Namespaced measurements keys
  'measurements.title': 'Measurements',
  'measurements.subtitle': 'Track and version customer measurements',
  'measurements.selectCustomer': 'Select Customer',
  'measurements.details': 'Details',
  'measurements.selectCustomerToView': 'Select a customer to view measurements',
  'measurements.recentMeasurements': 'Recent Measurements',
  'measurements.version': 'Version',
  'measurements.newMeasurements': 'New Measurements',
  'measurements.createNewSet': 'Create New Measurement Set',
  'measurements.saveMeasurements': 'Save Measurements',
  'measurements.notesPlaceholder': 'Additional measurement notes, alterations needed, etc.',
  'measurements.photoDocumentationSoon': 'Photo documentation coming soon',
  'measurements.uploadPhotos': 'Upload Photos',
  'measurements.measuredOn': 'Measured on',
  'measurements.history': 'History',
  'measurements.shoulderWidthBack': 'Shoulder Width (Back)',
  'measurements.waistLengthBack': 'Waist Length (Back)',
  'measurements.waistLengthFront': 'Waist Length (Front)',
  'measurements.bustHeight': 'Bust Height',
  'measurements.distanceBetweenBreasts': 'Distance Between Breasts',
  'measurements.shoulder': 'Shoulder',
  'measurements.armCircumference': 'Arm Circumference',
  'measurements.wristCircumference': 'Wrist Circumference',
  'measurements.sleeveLength': 'Sleeve Length',
  'measurements.chestCircumference': 'Chest Circumference',
  'measurements.bustCircumference': 'Bust Circumference',
  'measurements.waistCircumference': 'Waist Circumference',
  'measurements.hipCircumference': 'Hip Circumference',
  'measurements.abdomenCircumference': 'Abdomen Circumference',
  'measurements.hipUpper': 'Hip (Upper)',
  'measurements.skirtLength': 'Skirt Length',
  'measurements.height': 'Height',
  'measurements.noMeasurementsFound': 'No measurements found for this customer',
  'measurements.noMeasurementsRecorded': 'No measurements recorded yet',
  'measurements.hideComparison': 'Hide Comparison',
  'measurements.comparePrevious': 'Compare Previous',
  'measurements.compare': 'Compare',
  'measurements.comparingWithVersion': 'Comparing with Version',
  'measurements.success.saved': 'Measurements saved successfully',
  'measurements.by': 'by',
  'measurements.errors.loadFailed': 'Failed to load measurements',
  'measurements.errors.selectCustomer': 'Please select a customer',
  'measurements.errors.saveFailed': 'Failed to save measurements',
  'measurements.dialog.title': 'Measurement Details - Version {version}',
  'measurements.dialog.photoTab': 'Photo',
  'measurements.dialog.coreBodyMeasurements': 'Core Body Measurements',
  'measurements.dialog.circumferenceMeasurements': 'Circumference Measurements',
  'measurements.dialog.lengthMeasurements': 'Length Measurements',
  'measurements.dialog.detailMeasurements': 'Detail Measurements',
  'measurements.dialog.measurementInformation': 'Measurement Information',
  'measurements.dialog.versionBadge': 'Version {version}',
  'measurements.dialog.takenOn': 'Taken on:',
  'measurements.dialog.measuredBy': 'Measured by:',
  'measurements.dialog.measurementPhoto': 'Measurement Photo',
  'measurements.dialog.measurementReferenceAlt': 'Measurement reference',
  'measurements.dialog.noPhotoAvailable': 'No photo available',
};
